import DocumentsList from "./DocumentsList";
import Description from "@material-ui/icons/Description";

const Documents = {
    list: DocumentsList,
    icon: Description
};

export default Documents;
